import InvoiceCollection from "./cashier/InvoiceCollection";
import CustomerCollection from "./crm/CustomerCollection";
import CustomerContactCollection from "./crm/CustomerContactCollection";
import CustomerLocationCollection from "./crm/CustomerLocationCollection";
import AnalysisCollection from "./lab/AnalysisCollection";
import AnalyteCollection from "./lab/AnalyteCollection";
import AnalyteResultCollection from "./lab/AnalyteResultCollection";
import AnalyteResultStatusCollection from "./lab/AnalyteResultStatusCollection";
import AttributeListCollection from "./lab/AttributeListCollection";
import InstrumentCollection from "./lab/InstrumentCollection";
import InstrumentInstanceCollection from "./lab/InstrumentInstanceCollection";
import InstrumentInstanceScheduleCollection from "./lab/InstrumentInstanceScheduleCollection";
import InstrumentJigCollection from "./lab/InstrumentJigCollection";
import LaboratoryCollection from "./lab/LaboratoryCollection";
import ManagedListCollection from "./lab/ManagedListCollection";
import MeasureUnitCollection from "./lab/MeasureUnitCollection";
import NoteCollection from "./lab/NoteCollection";
import PermissionCollection from "./lab/PermissionCollection";
import PrepProcessCollection from "./lab/PrepProcessCollection";
import PrepTaskCollection from "./lab/PrepTaskCollection";
import PrepWorkflowCollection from "./lab/PrepWorkflowCollection";
import ProcessScheduleSampleCollection from "./lab/ProcessScheduleSampleCollection";
import ProjectCollection from "./lab/ProjectCollection";
import ProjectStatusCollection from "./lab/ProjectStatusCollection";
import ResultCollection from "./result/ResultCollection";
import SampleCollection from "./lab/SampleCollection";
import SampleStatusCollection from "./lab/SampleStatusCollection";
import SampleTypeCollection from "./lab/SampleTypeCollection";
import ScheduleCollection from "./lab/ScheduleCollection";
import ScheduleStatusCollection from "./lab/ScheduleStatusCollection";
import SubmissionCollection from "./lab/SubmissionCollection";
import SubmissionStatusCollection from "./lab/SubmissionStatusCollection";
import TestPackageAnalyteCollection from "./lab/TestPackageAnalyteCollection";
import TestPackageCollection from "./lab/TestPackageCollection";
import TestPackageGroupCollection from "./lab/TestPackageGroupCollection";
import TestPackageSampleCollection from "./lab/TestPackageSampleCollection";
import TestProcessCollection from "./lab/TestProcessCollection";
import TestTaskCollection from "./lab/TestTaskCollection";
import TestWorkflowCollection from "./lab/TestWorkflowCollection";
import WorkGroupCollection from "./lab/WorkGroupCollection";
import ResultExportCollection from "./lab/ResultExportCollection";
import QualityControlCollection from "./lab/QualityControlCollection";
import ScheduleSampleCollection from "./lab/ScheduleSampleCollection";
import TurnaroundCollection from "./lab/TurnaroundCollection";
import ActivityCollection from "./crm/ActivityCollection";
import SampleAnalytesCollection from "./lab/SampleAnalytesCollection";
import AnalyteRangeCollection from "./lab/AnalyteRangeCollection";
import CustomerGrowerCollection from "./crm/CustomerGrowerCollection";
import CustomerFieldCollection from "./crm/CustomerFieldCollection";

const collections = {
  activity: ActivityCollection,
  analysis: AnalysisCollection,
  analyte: AnalyteCollection,
  analyte_range: AnalyteRangeCollection,
  analyte_result: AnalyteResultCollection,
  analyte_result_status: AnalyteResultStatusCollection,
  attribute_list: AttributeListCollection,
  customer: CustomerCollection,
  customer_contact: CustomerContactCollection,
  customer_location: CustomerLocationCollection,
  customer_grower: CustomerGrowerCollection,
  customer_field: CustomerFieldCollection,
  instrument: InstrumentCollection,
  instrument_instance: InstrumentInstanceCollection,
  instrument_instance_schedule: InstrumentInstanceScheduleCollection,
  instrument_jig: InstrumentJigCollection,
  invoice: InvoiceCollection,
  laboratory: LaboratoryCollection,
  managed_list: ManagedListCollection,
  measure_unit: MeasureUnitCollection,
  note: NoteCollection,
  permission: PermissionCollection,
  prep_process: PrepProcessCollection,
  prep_task: PrepTaskCollection,
  prep_workflow: PrepWorkflowCollection,
  process_schedule_sample: ProcessScheduleSampleCollection,
  project: ProjectCollection,
  project_status: ProjectStatusCollection,
  quality_control: QualityControlCollection,
  result: ResultCollection,
  result_export: ResultExportCollection,
  sample: SampleCollection,
  sample_analytes: SampleAnalytesCollection,
  sample_status: SampleStatusCollection,
  sample_type: SampleTypeCollection,
  schedule: ScheduleCollection,
  schedule_sample: ScheduleSampleCollection,
  schedule_status: ScheduleStatusCollection,
  submission: SubmissionCollection,
  submission_status: SubmissionStatusCollection,
  test_package_analyte: TestPackageAnalyteCollection,
  test_package: TestPackageCollection,
  test_package_group: TestPackageGroupCollection,
  test_package_sample: TestPackageSampleCollection,
  test_process: TestProcessCollection,
  test_task: TestTaskCollection,
  test_workflow: TestWorkflowCollection,
  turnaround: TurnaroundCollection,
  work_group: WorkGroupCollection
};

export const CollectionFactory = {
  get: name => collections[name]
};
